import styled from 'styled-components';
import { LinkWithNativeEvents } from '../_common/link/link';

const VehicleDetailsWrapper = styled.div<{
  hasClickedAddVehicleButton: string | null;
}>`
  align-content: center;
  border-radius: ${(props) => props.theme.border.radius};
  background-color: ${(props) => props.theme.color.neutral.v100};
  display: flex;
  justify-content: left;
  flex-direction: column;
  padding: 24px;
  border: 1px solid #d9dde9;
  box-sizing: border-box;
  box-shadow: ${(props) => props.theme.depth.elevation.v200};
  border-radius: 8px;
  margin-bottom: ${({ hasClickedAddVehicleButton }) => (hasClickedAddVehicleButton ? 0 : '16px')};

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    flex-direction: row;
    padding: 24px;
  }
`;

const Image = styled.img`
  width: 100%;
  border-radius: 4px;
  background-color: #c4c4c4;
  max-height: 148px;
  object-fit: cover;

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    max-width: 284px;
  }
`;

const CarInfo = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: ${(props) => props.theme.breakpoint.sm}px) and (max-width: ${(props) =>
      props.theme.breakpoint.md}px) {
    padding: 15px 0 0;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    padding: 0 0 0 32px;
  }
`;

const Make = styled.h4`
  color: ${(props) => props.theme.color.primary.v600};
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  line-height: 24px;
  margin: 16px 0 0px 0;
  text-transform: capitalize;

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    margin: 0;
  }
`;

const Model = styled.h5`
  color: #6d7184;
  font-weight: 400;
  font-size: 18px;
  line-height: 28px;
  margin: 4px 0 0;

  @media (max-width: 320px) {
    font-weight: 400;
    font-size: 18px;
    line-height: 28px;
    font-size: 16px;
  }
`;

const Vin = styled(Model)`
  margin-top: 8px;
  text-transform: uppercase;
`;

const PurchaseInfo = styled(Vin)`
  margin-top: 8px;
  text-transform: unset;
`;

const Date = styled.span`
  text-transform: uppercase;
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
`;

const VdpLinkWrapper = styled.div`
  padding-top: 8px;
`;

const VdpLink = styled(LinkWithNativeEvents)`
  text-transform: uppercase;
  font-weight: 700;
  font-size: 14px;
  line-height: 22px;
  color: ${(props) => props.theme.color.primary.v200};
`;

export { VehicleDetailsWrapper, Image, CarInfo, Make, Model, Vin, PurchaseInfo, Date, VdpLinkWrapper, VdpLink };
